import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { getCategoryLabel } from "../../../constants/automapPartnershipConstants";
import { fetchPartnerAnalytics } from "../../../services/automapPartnershipApi";
import { AdminPartnersNav } from "../partners/AdminPartnersShared";

export default function AdminPartnerAnalyticsPage() {
  const [range, setRange] = useState("last_30_days");
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchPartnerAnalytics(range)
      .then((d) => setAnalytics(d.analytics))
      .finally(() => setLoading(false));
  }, [range]);

  const t = analytics?.totals || {};

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Analytics" title="Partner analytics" />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnersNav active="analytics" />
      <main className="admin-console__main wrap">
        <select value={range} onChange={(e) => setRange(e.target.value)}>
          <option value="today">Hoy</option>
          <option value="last_7_days">7 días</option>
          <option value="last_30_days">30 días</option>
          <option value="this_month">Este mes</option>
        </select>
        {loading ? <p>Cargando…</p> : (
          <>
            <div className="admin-dashboard__metrics-grid" style={{ marginTop: "1rem" }}>
              <div className="admin-dashboard__metric-card"><span>Leads</span><strong>{t.leads}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Calificados</span><strong>{t.qualified}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Sin asignar</span><strong>{t.unassigned}</strong></div>
              <div className="admin-dashboard__metric-card"><span>CTA clicks</span><strong>{t.serviceCtaClicks}</strong></div>
            </div>
            <section className="dealer-state-box">
              <h3>Por categoría</h3>
              <ul>{Object.entries(analytics?.byCategory || {}).map(([k, v]) => <li key={k}>{getCategoryLabel(k)}: {v}</li>)}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Por aliado</h3>
              <ul>{Object.entries(analytics?.byPartner || {}).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Por origen / componente</h3>
              <ul>{Object.entries(analytics?.bySource || {}).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
              <ul>{Object.entries(analytics?.byComponent || {}).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
            </section>
            <p className="muted">Conversión y respuesta aliado: placeholders — TODO billing.</p>
            <Link to="/admin/partners">Ver aliados</Link>
          </>
        )}
      </main>
    </AdminPageLayout>
  );
}
